import { useState } from 'react';

import DetailShell from './DetailShell';
import DetailTabContent from './DetailTabContent';

/**
 * Detail view (static route fallback).
 * @param {object} props
 * @param {ApiPage} [props.page]
 * @returns {JSX.Element}
 */
function Detail({ page }) {
  const [isTabTransitioning, setIsTabTransitioning] = useState(false);

  return (
    <>
      <DetailShell
        page={page}
        isTabTransitioning={isTabTransitioning}
        setIsTabTransitioning={setIsTabTransitioning}
      />
      <DetailTabContent
        key={page?.path}
        page={page}
        isLoading={isTabTransitioning}
      />
    </>
  );
}

export default Detail;
